import { ArrowRight } from "lucide-react";

export default function CTAButton({
    children,
    onClick,
    href,
    download = false,
    dark = false,
    testid,
    className = "",
}) {
    const cls = `group inline-flex items-center justify-center gap-3 border px-6 lg:px-8 py-3 lg:py-4 mono text-[11px] tracking-[0.25em] uppercase transition-all duration-300 ${
        dark
            ? "border-paper text-paper hover:bg-paper hover:text-ink"
            : "border-ink text-ink hover:bg-ink hover:text-paper"
    } ${className}`;
    const inner = (
        <>
            {children}
            <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1.5" />
        </>
    );
    if (href) {
        return (
            <a
                href={href}
                download={download || undefined}
                onClick={onClick}
                data-testid={testid}
                className={cls}
            >
                {inner}
            </a>
        );
    }
    return (
        <button onClick={onClick} data-testid={testid} className={cls}>
            {inner}
        </button>
    );
}
